import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TelegramLeads from "../pages/telegram-leads/page";
import AiSales from "../pages/ai-sales/page";
import Competitors from "../pages/competitors/page";
import Integrations from "../pages/integrations/page";
import LeadsTurnkey from "../pages/leads-turnkey/page";
import MassMailing from "../pages/mass-mailing/page";
import NicheDetail from "../pages/niches/page";
import Privacy from "@/pages/legal/privacy";
import Terms from "@/pages/legal/terms";
import Offer from "@/pages/legal/offer";
import PartnerProgram from "@/pages/partner-program/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/telegram-leads",
    element: <TelegramLeads />,
  },
  {
    path: "/ai-sales",
    element: <AiSales />,
  },
  {
    path: "/competitors",
    element: <Competitors />,
  },
  {
    path: "/integrations",
    element: <Integrations />,
  },
  {
    path: "/leads-turnkey",
    element: <LeadsTurnkey />,
  },
  {
    path: "/mass-mailing",
    element: <MassMailing />,
  },
  {
    path: "/niches/:slug",
    element: <NicheDetail />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/offer",
    element: <Offer />,
  },
  {
    path: "/partner",
    element: <PartnerProgram />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;